export const ROLE_SENTO = 1;

export const ROLE_AGENCY = 2;

export const SALES_ROLE = 0;